import { usePageAnalytics } from "@/hooks/usePageAnalytics"
import { useInactivityLogout } from "@/hooks/useInactivityLogout"

function AnalyticsTracker() {
  usePageAnalytics()
  useInactivityLogout()
  return null
}

export default AnalyticsTracker
